const handleDeleteEquipmentServiceFail = {
  title: 'SERVIÇO NÃO PODE SER DELETADO',
  message: 'Não pode ser deletado. Utilizado por',
  companies: 'Empresas',
  items: 'Itens',
  equipmentmodels: 'Tipos de Equipamentos',
  equipments: 'Equipamentos',
  inspections: 'Inspeções',
  itemverifications: 'Itens de Verificação',
  default: 'Coleção Genérica'
};

export default handleDeleteEquipmentServiceFail;
